export const PRE_ASSESSMENT_STATUSES = {
  STARTED: 'STARTED',
  APPROVED: 'APPROVED',
  UNRESOLVED: 'UNRESOLVED',
  REJECTED: 'REJECTED',
};

export const RETURN_RATES = {
  RETURN_RATES_PER_GROUP: 'returnRatesPerGroup',
  RETURN_RATES_PER_CATEGORY: 'returnRatesPerCategory',
  RETURN_RATES_PER_COUNTRY: 'returnRatesPerCountry',
  OUTSTANDING_RETURNS_VARIABLES: 'outstandingReturnsVariable',
};

export const POTENTIAL_MERCHANT_LOSSES = {
  YEAR_IN_DAYS: 365,
  QUARTER_IN_DAYS: 90,
  MAX_THRESHOLDS: 750000,
};

export const PAYMENT_INTERVAL = {
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
};

export const GOOD_CATEGORY = {
  ADULT_SHOES_AND_CLOTHING: 'ADULT_SHOES_AND_CLOTHING',
  AUTOMOTIVE_PARTS_AND_ACCESSORIES: 'AUTOMOTIVE_PARTS_AND_ACCESSORIES',
  BAGS_AND_WALLETS: 'BAGS_AND_WALLETS',
  BODY_AND_HAIR_CARE: 'BODY_AND_HAIR_CARE',
  BOOK_AND_MAGAZINES: 'BOOK_AND_MAGAZINES',
  CANDY: 'CANDY',
  CAR_ELECTRONICS: 'CAR_ELECTRONICS',
  CHILDREN_CLOTHES_AND_NURTURING_PRODUCTS: 'CHILDREN_CLOTHES_AND_NURTURING_PRODUCTS',
  CHILDREN_TOYS: 'CHILDREN_TOYS',
  CLEANING_AND_SANITARY: 'CLEANING_AND_SANITARY',
  COLLECTIBLES: 'COLLECTIBLES',
  CONCEPT_STORES_AND_MISCELLANEOUS: 'CONCEPT_STORES_AND_MISCELLANEOUS',
  COSMETICS: 'COSMETICS',
  COSTUMES_AND_PARTY_SUPPLIES: 'COSTUMES_AND_PARTY_SUPPLIES',
  DATING_SERVICES: 'DATING_SERVICES',
  DECORATION_AND_ART: 'DECORATION_AND_ART',
  DIETARY_SUPPLEMENTS: 'DIETARY_SUPPLEMENTS',
  DIGITAL_SERVICES: 'DIGITAL_SERVICES',
  DIVERSIFIED_CHILDREN_PRODUCTS: 'DIVERSIFIED_CHILDREN_PRODUCTS',
  DIVERSIFIED_ELECTRONICS: 'DIVERSIFIED_ELECTRONICS',
  DIVERSIFIED_ENTERTAINMENT: 'DIVERSIFIED_ENTERTAINMENT',
  DIVERSIFIED_EROTIC_MATERIAL: 'DIVERSIFIED_EROTIC_MATERIAL',
  DIVERSIFIED_HOME_AND_GARDEN_PRODUCTS: 'DIVERSIFIED_HOME_AND_GARDEN_PRODUCTS',
  DIVERSIFIED_JEWELRY_AND_ACCESSORIES: 'DIVERSIFIED_JEWELRY_AND_ACCESSORIES',
  DIVERSIFIED_HEALTH_AND_BEAUTY_PRODUCTS: 'DIVERSIFIED_HEALTH_AND_BEAUTY_PRODUCTS',
  EDUCATION: 'EDUCATION',
  ELECTRONIC_EQUIPMENT_AND_RELATED_ACCESSORIES: 'ELECTRONIC_EQUIPMENT_AND_RELATED_ACCESSORIES',
  EROTIC_CLOTHING_AND_ACCESSORIES: 'EROTIC_CLOTHING_AND_ACCESSORIES',
  EVENT_TICKETS: 'EVENT_TICKETS',
  FOOD_AND_BEVERAGE: 'FOOD_AND_BEVERAGE',
  FRAGRANCES: 'FRAGRANCES',
  FURNITURE: 'FURNITURE',
  GENERAL_SHOES_AND_CLOTHING: 'GENERAL_SHOES_AND_CLOTHING',
  HOBBY_ARTICLES: 'HOBBY_ARTICLES',
  HOUSEHOLD_ELECTRONICS: 'HOUSEHOLD_ELECTRONICS',
  JEWELRY_AND_WATCHES: 'JEWELRY_AND_WATCHES',
  KITCHENWARE: 'KITCHENWARE',
  MARKETPLACES: 'MARKETPLACES',
  MUSIC_AND_MOVIES: 'MUSIC_AND_MOVIES',
  MUSICAL_INSTRUMENTS_AND_EQUIPMENT: 'MUSICAL_INSTRUMENTS_AND_EQUIPMENT',
  NON_PRESCRIPTION_SUNGLASSES_AND_LENSES: 'NON_PRESCRIPTION_SUNGLASSES_AND_LENSES',
  OFFICE_MACHINES_AND_RELATED_ACCESSORIES: 'OFFICE_MACHINES_AND_RELATED_ACCESSORIES',
  OTHER_SERVICES: 'OTHER_SERVICES',
  PERSONAL_CARE_AND_BODY_IMPROVEMENT: 'PERSONAL_CARE_AND_BODY_IMPROVEMENT',
  PET_SUPPLIES: 'PET_SUPPLIES',
  PHARMACEUTICAL_PRODUCTS: 'PHARMACEUTICAL_PRODUCTS',
  PLANTS_AND_FLOWERS: 'PLANTS_AND_FLOWERS',
  PRESCRIPTION_OPTICS: 'PRESCRIPTION_OPTICS',
  PRINTS_AND_PHOTOS: 'PRINTS_AND_PHOTOS',
  SAFETY_PRODUCTS: 'SAFETY_PRODUCTS',
  SEX_TOYS: 'SEX_TOYS',
  SPORTS_GEAR_AND_OUTDOOR: 'SPORTS_GEAR_AND_OUTDOOR',
  TOBACCO: 'TOBACCO',
  TOOLS_AND_HOME_IMPROVEMENT: 'TOOLS_AND_HOME_IMPROVEMENT',
  TRAVEL_SERVICES: 'TRAVEL_SERVICES',
  UNDERWEAR: 'UNDERWEAR',
  VIDEO_GAMES_AND_RELATED_ACCESSORIES: 'VIDEO_GAMES_AND_RELATED_ACCESSORIES',
  WHEELS_AND_TIRES: 'WHEELS_AND_TIRES',
  WINE_BEER_AND_LIQUOR: 'WINE_BEER_AND_LIQUOR',
  YOUTHFUL_SHOES_AND_CLOTHING: 'YOUTHFUL_SHOES_AND_CLOTHING',
  GAMBLING_BETTING_CASINOS_AND_LOTTERY: 'GAMBLING_BETTING_CASINOS_AND_LOTTERY',
  CHARITIES_AND_NGO: 'CHARITIES_AND_NGO',
  EROTIC_SERVICES: 'EROTIC_SERVICES',
  FINANCIAL_SERVICES_CRYPTO: 'FINANCIAL_SERVICES_CRYPTO',
  FINANCIAL_SERVICES_MSB: 'FINANCIAL_SERVICES_MSB',
  FINANCIAL_SERVICES_E_WALLETS: 'FINANCIAL_SERVICES_E_WALLETS',
  FINANCIAL_SERVICES_TRADING: 'FINANCIAL_SERVICES_TRADING',
  SOCIAL_PLATFORMS_COMMUNITIES: 'SOCIAL_PLATFORMS_COMMUNITIES',
  TRAVEL_AIR_TRAVEL_AND_CRUISE_OPERATORS: 'Travel - Air Travel & Cruise Operators',
  TRAVEL_BROKER_AND_AGENCIES: 'Travel - Broker & Agencies',
  TRAVEL_GROUND_TRANSPORTATION: 'Travel - Ground Transportation',
  TRAVEL_ACCOMMODATION_AND_RESORTS: 'Travel - Accommodation & Resorts',
  EVENT_ORGANIZER: 'Event - Organizer',
  EVENT_BROKER_AND_AGENCIES: 'Event - Broker & Agencies',
};

export const BUSINESS_CONCEPT = {
  VOUCHER: 'VOUCHER',
  MEMBERSHIP: 'MEMBERSHIP',
  SUBSCRIPTION: 'SUBSCRIPTION',
  PHARMACIES: 'PHARMACIES',
  MARKETPLACES: 'MARKETPLACES',
  FIREARM_DEALERS: 'FIREARM_DEALERS',
  AUCTIONS: 'AUCTIONS',
  ALCOHOL: 'ALCOHOL',
  TOBACCO: 'TOBACCO',
  HEMP_CBD_THC: 'HEMP_CBD_THC',
  DONATIONS_CHARITY: 'DONATIONS_CHARITY',
  EDUCATIONAL_COURSES: 'EDUCATIONAL_COURSES',
  FOOD_DELIVERY: 'FOOD_DELIVERY',
  CUSTOMISED_PRE_ORDER_FURNITURE: 'CUSTOMISED_PRE_ORDER_FURNITURE',
  DIGITAL_CONTENT: 'DIGITAL_CONTENT',
  GAMING_INDUSTRY: 'GAMING_INDUSTRY',
  TRADITIONAL_SALE_OF_GOODS: 'TRADITIONAL_SALE_OF_GOODS',
};

export const THRESHOLD_CATEGORIES = [
  GOOD_CATEGORY.TRAVEL_SERVICES,
  GOOD_CATEGORY.EVENT_TICKETS,
  GOOD_CATEGORY.DIGITAL_SERVICES,
  GOOD_CATEGORY.OTHER_SERVICES,
  GOOD_CATEGORY.EDUCATION,
  GOOD_CATEGORY.COSTUMES_AND_PARTY_SUPPLIES,
];

export const THRESHOLD_BUSINESS_CONCEPTS = [
  BUSINESS_CONCEPT.VOUCHER,
  BUSINESS_CONCEPT.MEMBERSHIP,
  BUSINESS_CONCEPT.SUBSCRIPTION,
];

export const MIA_BUSINESS_CONCEPTS = [
  BUSINESS_CONCEPT.AUCTIONS,
  BUSINESS_CONCEPT.MARKETPLACES,
  BUSINESS_CONCEPT.FIREARM_DEALERS,
  BUSINESS_CONCEPT.PHARMACIES,
  BUSINESS_CONCEPT.ALCOHOL,
  BUSINESS_CONCEPT.TOBACCO,
  BUSINESS_CONCEPT.HEMP_CBD_THC,
  BUSINESS_CONCEPT.DONATIONS_CHARITY,
];
